// removed by extract-text-webpack-plugin
module.exports = {"root":"i0FKI_ZmMSSJypxzC9PyZ","suggestion-list":"hELlXxUZ8Pr-C2PabUUTN","input":"_18_-LdOjkJKTBlLtvOZvFV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/autocomplete.scss
// module id = 1325
// module chunks = 0